import { FC } from 'react';
import { Search } from 'lucide-react';
import { cn } from '../../../../utils/cn';

interface ClientSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export const ClientSearch: FC<ClientSearchProps> = ({ searchQuery, onSearchChange }) => {
  return (
    <div className="relative w-full sm:w-72">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 dark:text-slate-500" />
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search clients..."
        className={cn(
          'w-full pl-10 pr-4 py-2 text-sm rounded-lg border',
          'bg-white dark:bg-slate-800',
          'text-gray-900 dark:text-slate-100',
          'placeholder-gray-400 dark:placeholder-slate-500',
          'border-gray-300 dark:border-slate-600',
          'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
        )}
        aria-label="Search clients by name"
      />
    </div>
  );
};
